__webpack_require__.p = "https://assets.themednet.org/js/mednet-anterior/";